export const ROLE_LABELS = {
  administrador: 'Administrador',
  programador: 'Programador',
  coordenacao: 'Coordenação',
  veterinario: 'Veterinário',
  tratador: 'Tratador',
  laboratorio: 'Laboratório',
  painel_monitoramento: 'Painel de Monitoramento',
};

const ROLE_DEFAULT_PERMISSIONS = {
  administrador: [
    'users.view', 'users.create', 'users.edit', 'users.status', 'users.password.reset', 'users.delete',
    'users.roles.view', 'users.permissions.edit',
    'bases.manage', 'organizations.manage', 'sequence.manage', 'species.manage', 'system.settings.manage',
    'animals.view', 'animals.edit_admin_data', 'animals.edit_clinical', 'animals.transfer', 'animals.delete',
    'daily_records.view', 'daily_records.create', 'daily_records.edit', 'daily_records.delete', 'daily_records.attach',
    'records.delete',
    'reports.view', 'dashboards.view',
    'medication.dashboard.view', 'medication.execute', 'medication.prescribe',
    'feeding.dashboard.view', 'feeding.record', 'feeding.plan.manage',
    'cleaning.view', 'cleaning.execute', 'cleaning.manage',
    'exams.view', 'exams.create', 'exams.update', 'exams.attach', 'exams.delete',
    'necropsy.view', 'necropsy.create', 'necropsy.update', 'necropsy.attach', 'necropsy.conclude',
    'lab_requests.view', 'lab_requests.update',
    'support_tickets.view', 'support_tickets.create',
    'qr.use', 'pdfs.generate',
  ],
  coordenacao: [
    'users.view', 'users.edit', 'users.status', 'users.roles.view',
    'animals.view', 'animals.edit_admin_data', 'animals.edit_clinical', 'animals.transfer',
    'daily_records.view', 'daily_records.create', 'daily_records.edit', 'daily_records.attach',
    'reports.view', 'dashboards.view',
    'medication.dashboard.view', 'medication.execute', 'medication.prescribe',
    'feeding.dashboard.view', 'feeding.record', 'feeding.plan.manage',
    'cleaning.view', 'cleaning.execute', 'cleaning.manage',
    'exams.view', 'exams.create', 'exams.update', 'exams.attach', 'exams.delete',
    'necropsy.view',
    'lab_requests.view', 'lab_requests.update',
    'support_tickets.view', 'support_tickets.create',
    'qr.use', 'pdfs.generate',
  ],
  veterinario: [
    'animals.view', 'animals.edit_clinical', 'animals.transfer',
    'daily_records.view', 'daily_records.create', 'daily_records.edit', 'daily_records.attach',
    'dashboards.view',
    'medication.dashboard.view', 'medication.execute', 'medication.prescribe',
    'feeding.dashboard.view', 'feeding.record', 'feeding.plan.manage',
    'cleaning.view', 'cleaning.schedule.create',
    'exams.view', 'exams.create', 'exams.update', 'exams.attach',
    'necropsy.view', 'necropsy.create', 'necropsy.update', 'necropsy.attach', 'necropsy.conclude',
    'lab_requests.view', 'lab_requests.update',
    'support_tickets.view', 'support_tickets.create',
    'qr.use', 'pdfs.generate',
  ],
  tratador: [
    'animals.view',
    'daily_records.view', 'daily_records.create', 'daily_records.edit', 'daily_records.attach',
    'dashboards.view',
    'medication.dashboard.view', 'medication.execute',
    'feeding.dashboard.view', 'feeding.record',
    'cleaning.view', 'cleaning.execute',
    'support_tickets.view', 'support_tickets.create',
    'qr.use', 'pdfs.generate',
  ],
  laboratorio: [
    'animals.view',
    'daily_records.view',
    'dashboards.view',
    'exams.view', 'exams.create', 'exams.update', 'exams.attach',
    'lab_requests.view', 'lab_requests.update',
    'support_tickets.view', 'support_tickets.create',
    'qr.use',
  ],
  painel_monitoramento: [
    'dashboards.view',
    'medication.dashboard.view',
    'feeding.dashboard.view',
    'cleaning.view',
  ],
  programador: [
    'support_tickets.view', 'support_tickets.create', 'support_tickets.manage', 'support.commercial.approve',
    'cleaning.view', 'cleaning.execute', 'cleaning.manage',
    'species.manage',
  ],
};

export const hasPermission = (user, permission) => {
  if (!user) return false;
  if (user.role === 'programador') return true;
  return (
    (Array.isArray(user.permissions) && user.permissions.includes(permission))
    || (ROLE_DEFAULT_PERMISSIONS[user.role] || []).includes(permission)
  );
};

export const hasAnyPermission = (user, permissions = []) => {
  return permissions.some((permission) => hasPermission(user, permission));
};

export const getRoleLabel = (role) => ROLE_LABELS[role] || role;

export const getRoleBadgeClass = (role) => {
  switch (role) {
    case 'administrador':
      return 'bg-slate-900 text-white';
    case 'programador':
      return 'bg-black text-white';
    case 'coordenacao':
      return 'bg-emerald-100 text-emerald-800';
    case 'veterinario':
      return 'bg-sky-100 text-sky-800';
    case 'tratador':
      return 'bg-amber-100 text-amber-800';
    case 'laboratorio':
      return 'bg-violet-100 text-violet-800';
    case 'painel_monitoramento':
      return 'bg-cyan-100 text-cyan-800';
    default:
      return 'bg-gray-100 text-gray-700';
  }
};

export const getStatusBadgeClass = (status) => {
  return status === 'active'
    ? 'bg-emerald-100 text-emerald-800'
    : 'bg-gray-100 text-gray-700';
};
